import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/TTDragonTigerLion/tableBg.webp";
import newRoundImg from "../images/TTDragonTigerLion/New_Round.svg";
import ideal from "../images/TTDragonTigerLion/idle.gif";
import clapping from "../images/TTDragonTigerLion/clapping.gif";
import crown from "../images/TTDragonTigerLion/crown.png";
import closedCard from "../images/TTDragonTigerLion/closed-card.jpg";
import { cards } from "../images/index";
import welcome from "../images/TTDragonTigerLion/welcome.gif";
import GameAreaLoader from "../../Loader/GameAreaLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";

export default function GameScreen({ bettingClosed, animationTime, socketData, remainingTime }) {

  const [dragonVisible, setDragonVisible] = useState(false);
  const [tigerVisible, setTigerVisible] = useState(false);
  const [lionVisible, setLionVisible] = useState(false);

const roundId = socketData?.roundId;
const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);



  const mapCardStringToAsset = (cardString) => {
    if (!cardString || typeof cardString !== "string") return closedCard;
    const raw = cardString.trim().toUpperCase().replace(/\.(WEBP|PNG|JPE?G|SVG)$/i, "");
    if (cards[raw]) return cards[raw];
    if (cards[`${raw}.webp`]) return cards[`${raw}.webp`];
    return closedCard;
  };

  const getMainWinner = (outcome) => {
    if (!outcome || typeof outcome !== "string") return null;
    const parts = outcome.toUpperCase().trim().split(",");
    const first = parts[0];
    if (["DRAGON", "TIGER", "LION"].includes(first)) return first;
    return null;
  };

  const mainWinner = getMainWinner(settlement?.outcome);


  useEffect(() => {
    if (!bettingClosed || !settlement) {
      setDragonVisible(false);
      setTigerVisible(false);
      setLionVisible(false);
      return;
    }

    if (settlement.dragonCard) setDragonVisible(true);
    if (settlement.tigerCard)  setTigerVisible(true);
    if (settlement.lionCard)   setLionVisible(true);

  }, [socketData, bettingClosed]);

 
  const currentGif = !bettingClosed
    ? welcome
    : settlement?.clapping
      ? clapping
      : ideal;

  
  const showWinner = bettingClosed && settlement?.winner && mainWinner;

  const showNewRound = !bettingClosed;

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.gameContainer}>
        <div className={styles.mainGameArea}>
          <div className={styles.videoArea}>
            <div className={styles.videoContainer}>
              <img
                src={backgroundImage}
                alt="Dragon Tiger Lion"
                className={styles.backgroundImage}
                draggable={false}
              />

              <div className={styles.gifOverlay}>
                <img
                  src={currentGif}
                  alt="animation"
                  className={styles.gifImage}
                  draggable={false}
                />
              </div>

              <div className={styles.cardsContainer}>
                <div className={styles.cardsRow}>

                  <div className={`${styles.dragonCard} ${mainWinner === "DRAGON" ? styles.winnerCard : ""}`}>
                    <img
                      src={dragonVisible ? mapCardStringToAsset(settlement?.dragonCard) : closedCard}
                      alt="Dragon"
                      className={styles.cardImage}
                    />
                    <span className={styles.cardLabel}>Dragon</span>
                  </div>

                  <div className={`${styles.tigerCard} ${mainWinner === "TIGER" ? styles.winnerCard : ""}`}>
                    <img
                      src={tigerVisible ? mapCardStringToAsset(settlement?.tigerCard) : closedCard}
                      alt="Tiger"
                      className={styles.cardImage}
                    />
                    <span className={styles.cardLabel}>Tiger</span>
                  </div>

                  <div className={`${styles.lionCard} ${mainWinner === "LION" ? styles.winnerCard : ""}`}>
                    <img
                      src={lionVisible ? mapCardStringToAsset(settlement?.lionCard) : closedCard}
                      alt="Lion"
                      className={styles.cardImage}
                    />
                    <span className={styles.cardLabel}>Lion</span>
                  </div>

                </div>

                {showWinner && (
                  <div className={styles.winnerAnimation}>
                    <img src={crown} alt="Crown" className={styles.crownImage} />
                    <span className={styles.winnerText}>WINNER : {mainWinner}</span>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
        {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
      </div>
    </GameAreaLoader>
  );
}